import { useParams } from '@tanstack/react-router'

import { InvoiceServiceScreen } from '@/screens/InvoiceServiceScreen'
import { ServicePageShell } from '@/screens/ServicePageShell'
import { useSessionInvoiceService } from '@/screens/useSessionInvoiceService'

export function SessionInvoiceServiceScreenContainer() {
  const sessionId = useParams({
    from: '/sessions/$id/invoice',
    select: (d) => d.id,
  })
  const invoice = useSessionInvoiceService(sessionId, () => {})

  if (invoice.kind === 'loading') {
    return (
      <div className="bg-slate-50 text-slate-900">
        <main className="max-w-4xl mx-auto px-4 py-6 space-y-2">
          <h1 className="text-2xl font-semibold">Invoice Service</h1>
          <p className="text-sm text-slate-600">Loading invoice data…</p>
        </main>
      </div>
    )
  }

  if (invoice.kind === 'error') {
    return (
      <div className="bg-slate-50 text-slate-900">
        <main className="max-w-4xl mx-auto px-4 py-6 space-y-2">
          <h1 className="text-2xl font-semibold">Invoice Service</h1>
          <p className="text-sm text-slate-600">
            Unable to load invoice data right now.
          </p>
        </main>
      </div>
    )
  }

  if (invoice.kind === 'not_found') {
    return (
      <div className="bg-slate-50 text-slate-900">
        <main className="max-w-4xl mx-auto px-4 py-6 space-y-2">
          <h1 className="text-2xl font-semibold">Invoice Service</h1>
          <p className="text-sm text-slate-600">
            Remote session not found. Check the link or return to the sessions list.
          </p>
        </main>
      </div>
    )
  }

  const displayId = invoice.screenProps.publicId ?? sessionId

  return (
    <ServicePageShell
      serviceTypeLabel={invoice.screenProps.resourceLabel ?? 'TeamViewer Session'}
      serviceId={displayId}
      customerName={invoice.screenProps.customerName}
      customerId={invoice.screenProps.customerId}
      customerPublicId={invoice.screenProps.customerPublicId}
      scheduledAtLabel={invoice.screenProps.scheduledAt}
      initialIssue={invoice.screenProps.issueSummary}
      activeTab="invoice"
      basePath="/sessions/$id"
      currentStatus={invoice.screenProps.calloutStatus}
      statusChanges={invoice.screenProps.statusChanges}
      getAuthorDisplayName={invoice.screenProps.getAuthorDisplayName}
    >
      <InvoiceServiceScreen {...invoice.screenProps} showHeader={false} />
    </ServicePageShell>
  )
}
